import { render, staticRenderFns } from "./p19.vue?vue&type=template&id=38523274&scoped=true&"
import script from "./p19.vue?vue&type=script&lang=js&"
export * from "./p19.vue?vue&type=script&lang=js&"
import style0 from "./p19.vue?vue&type=style&index=0&id=38523274&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38523274",
  null
  
)

export default component.exports